import { getToken } from './auth';

const customFetch = async (url: string, options: RequestInit = {}) => {
  // Add common headers or other request interceptors here
  const token = getToken();
  const encodedToken = token ? btoa(`${token}:`) : ''; // Encode the token for Basic Auth
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Basic ${encodedToken}` } : {}),
  };

  const mergedOptions: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${backendUrl}${url}`, mergedOptions);
    
    // Handle authentication errors
    if (response.status === 401) {
      console.error('Authentication failed. Please log in again.');
      // You could redirect to login page here or handle it in the component
    }
    
    return response;
  } catch (error) {
    // Handle network or other errors
    console.error('Fetch error:', error);
    throw error;
  }
};

export default customFetch;
